import styled from 'styled-components';

export const Container = styled.div``;
export const FilterHeaderContainer = styled.div`
  margin-bottom: 20px;
`;
export const ColumnVisibilityMenu = styled.div`
  min-width: 220px;
  padding: 8px;
`;
export const ColumnVisibilityOption = styled.div`
  padding: 4px 8px;
`;
export const ColumnResetActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #f0f0f0;

  button {
    justify-content: flex-start;
  }
`;
export const TableHeaderActions = styled.div`
  width: 100%;
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  padding-bottom: 24px;
`;
export const TableTotalAmountContainer = styled.div`
  margin-bottom: 16px;
`;
export const DragColumnOverlay = styled.div`
  padding: 12px 16px;
  color: rgba(0, 0, 0, 0.88);
  font-weight: 600;
  background: #f0f0f0;
  border: 1px solid #d9d9d9;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
  cursor: move;
  user-select: none;
`;
export const DragColumnHeaderContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-width: 0;
  height: auto;
  min-height: 0;
  box-sizing: border-box;
  line-height: 2.5;

  .ant-table-column-sorters {
    display: flex;
    width: 100%;
    min-width: 0;
  }
`;
export const DragColumnHeaderTitle = styled.div`
  flex: 1;
  min-width: 0;
`;
export const DragColumnHandle = styled.button`
  z-index: 1;
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 0;
  color: grey;
  background: transparent;
  border: 0;
  cursor: grab;
  touch-action: none;

  &:active {
    color: #1668dc;
    cursor: grabbing;
  }
`;
